import Profile from './default'

export default Profile
